import { FC, useEffect, useRef, useState } from 'react';
import { IconButton } from '../icon-button/icon-button';
import { ArrowLeftIcon } from '../../assets/svg/arrow-left';
import s from './infinite-scroll.module.css';
import cn from 'classnames';

interface Props {
  onEnterView: () => void; // Колбэк, вызываемый при попадании во viewport
  threshold?: number; // Порог пересечения (по умолчанию 1.0)
  rootMargin?: string; // Отступы для области наблюдения (по умолчанию "0px")
}

export const InfiniteScroll: FC<Props> = (props) => {
  const { onEnterView, threshold = 1.0, rootMargin = '0px' } = props;
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          onEnterView(); // Вызываем колбэк при попадании во viewport
        }
      },
      { threshold, rootMargin },
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [onEnterView, threshold, rootMargin]);

  const [isVisible, setIsVisible] = useState(false);

  const body = document.getElementById('body');

  // Обработчик прокрутки
  const handleScroll = () => {
    const scrollTop = body?.scrollTop || 0;

    setIsVisible(scrollTop > 100);
  };

  // Прокрутка наверх
  const scrollToTop = () => {
    body?.scrollTo({
      top: 0,
      behavior: 'smooth', // Плавная прокрутка
    });
  };

  useEffect(() => {
    body?.addEventListener('scroll', handleScroll);
    return () => {
      body?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <IconButton onClick={scrollToTop} className={cn(s.fixed, s.button, !isVisible && s.hidden)}>
        <ArrowLeftIcon />
      </IconButton>
      <div ref={elementRef} className={s.bottom} />
    </>
  );
};
